// utils/home_state.js — M11: estado compartido entre setValue_controller y templates/home.
// Las plantillas del home interpolan los *count_class (ocultar/mostrar de tabs segun el
// endpoint count-product). Antes vivian en el scope del modulo de setValue_controller;
// al extraer las plantillas a templates/home.js quedaron fuera de scope (ReferenceError),
// asi que se centralizan aqui como objeto mutable compartido por ambos modulos.

export const homeState = {
  // Secciones con formulario fijo (block); lo escribe tpl_section (push) y lo lee
  // animation_for_sections() en setValue_controller para el pin ScrollMagic.
  id_array_for_section_with_block: [],
  // M11 (fix): variables de seccion que las plantillas ESCRIBEN y setValue_controller LEE.
  // Al extraer las plantillas a templates/home.js quedaron fuera de scope (ReferenceError
  // en modo estricto de webpack); se centralizan aqui como estado compartido.
  map_section_id: null,
  review_section_id: null,
  review_section: null,
  section_gallery: null,
  car_count_class: '',
  safari_count_class: '',
  accessible_tourism_count_class: '',
  rural_tourism_count_class: '',
  horseback_ride_count_class: '',
  events_count_class: '',
  excursion_count_class: '',
  home_count_class: '',
  buggy_count_class: '',
  transfers_count_class: '',
  bicicleta_count_class: '',
  campers_count_class: '',
  bike_count_class: '',
};
